<template>
  <div class="content">
    <div class="content-box">
      <div class="top">
        <p class="title">
          <span :class="flag == 1? 'active' : ''" @click="changeFlag(1)">核酸阴性</span>
          <span :class="flag == 2? 'active' : ''" @click="changeFlag(2)">核酸阳性</span>
          <span :class="flag == 3? 'active' : ''" @click="changeFlag(3)">无核酸报告</span>
        </p>
        <p style="width: 70%;text-align: right;padding: 1vh 1vw;">
          <el-input size="medium" v-model="search.userName" placeholder="请输入姓名" clearable></el-input>
          <el-input size="medium" v-model="search.idCard" placeholder="请输入身份证号" clearable style="margin: 0 1vw"></el-input>
          <el-input size="medium" v-model="search.timeSpan" placeholder="请输入核酸天数" clearable></el-input>
          <span class="button" style="margin: 0 1vw" @click="select">查询</span>
          <span class="button" @click="exportExcel">导出表单</span>
        </p>
      </div>
      <div style="padding: 0 1vw">
        <el-table :data="tableData" height="74vh" border stripe :header-cell-style="{ background: '#F5F7F9', color: '#909399' }">
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              <span>{{scope.row.index}}</span>
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <span>{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="身份证号">
            <template slot-scope="scope">
              <span>{{scope.row.idcard}}</span>
            </template>
          </el-table-column>
         <el-table-column label="安康码状态">
           <template slot-scope="scope">
             <img v-if="scope.row.health == 1" src="../../../assets/image/new/green.png" style="height: 6vh;">
             <img v-else-if="scope.row.health == 2" src="../../../assets/image/new/yellow.png" style="height: 6vh;">
             <img v-else-if="scope.row.health == 3" src="../../../assets/image/new/red.png" style="height: 6vh;">
             <img v-else-if="scope.row.health == 4" src="../../../assets/image/new/no.png" style="height: 6vh;">
          </template>
        </el-table-column>
        <el-table-column label="采集时间">
          <template slot-scope="scope">
            <span>{{scope.row.collectDatetime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="检测时间">
          <template slot-scope="scope">
            <span>{{scope.row.testingDatetime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="核酸状态">
           <template slot-scope="scope">
             <div v-if="search.flag == 1">
               <img style="width: 2vw" src="../../../assets/image/newAnKang/yin11.png">
               <p style="color: #23d715;">已过{{scope.row.timeSpan}}天</p>
             </div>
             <div v-else-if="search.flag == 2">
                <img style="width: 2vw" src="../../../assets/image/newAnKang/yang.png">
                <p style="color: #E32932;">已过{{scope.row.timeSpan}}天</p>
             </div>
             <div v-else-if="search.flag == 3">
                <p style="color: #bebebe;">暂无核酸</p>
             </div>
          </template>
        </el-table-column>
        </el-table>
      </div>
       <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="20"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="20"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import base from '../../../untils/base'
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  export default {
    data() {
      return {
        flag: 1,
        pageSize: 20,
        pageNum: 1,
        total: 0,
        tableData: [],
        search: {
          projectId: '',
          idCard: '',
          userName: '',
          flag: '',
          timeSpan: ''
        }
      }
    },
    created() {
      this.search.projectId = util.session.get('groupId')
      this.getData()
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getData()
      },
      select(){
        this.pageSize = 20
        this.pageNum = 1
        this.getData()
      },
      /// 
      changeFlag(flag){
        this.flag = flag
        this.pageSize = 20
        this.pageNum = 1
        this.getData()
      },

      getData(){
        this.search.flag = this.flag
        this.search.pageSize = this.pageSize
        this.search.pageNum = this.pageNum
        myHttp.findRecentWeekProjectPersonNucleicAcidPage(this.search).then(resp => {
          console.log(resp);
          if(resp.data.code == '200'){
            const data = resp.data.data.list.data || []
            for(let i=0;i<data.length;i++){
              data[i].index = (this.pageNum - 1) * this.pageSize + 1 + i
            }
            this.tableData =  data
            this.total = resp.data.data.list.totalCount
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      //  导出
      exportExcel(){
        let token = util.session.get('token')
        window.open(
          base.url + '/personNucleicAcidTesting/exportRecentWeekProjectPersonNucleicAcidList?projectId=' + this.search.projectId + '&idCard=' + this.search.idCard
          + '&userName=' + this.search.userName + '&flag=' + this.search.flag + '&timeSpan=' + this.search.timeSpan + '&accessToken=' + token
        )
      },
    },
  }
</script>

<style scoped>
.content{
  padding: 1vh 1vw;
}
.content-box{
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.top{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #E7E7E7;
  margin-bottom: 2vh;
}
.button{
  display: inline-block;
  font-size: 16px;
  color: #666;
  text-align: center;
  line-height: 34px;
  cursor: pointer;
  width: 80px;
  height: 34px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.el-input{
  width: 150px;
}
.title > span{
  margin-left: 18px;
  padding-bottom: 1.8vh;
  cursor: pointer;
}
.active{
  border-bottom: 2px solid #4D6EB1;
}
</style>